import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { autoBind } from "src/shared/decorators/autobind";
import { HttpRequestClient } from "src/infra/http/types";
import { httpUtils, HttpUtils } from "src/infra/http/utils";
import { IMedicineDeliveryDocumentRepository } from "src/domains/medicine-delivery/types";

export class MedicineDeliveryDocumentRepository
    implements IMedicineDeliveryDocumentRepository
{
    constructor(private http: HttpRequestClient) {}

    @autoBind
    getDocuments(requestId: number): Observable<Record<string, unknown>[]> {
        const endpoint =
            MedicineDeliveryDocumentRepository.getBaseUrl(requestId);
        return this.http.getJSON<Record<string, unknown>[]>(endpoint, {
            isPublicRequest: false,
            customHeader: {
                ...httpUtils.getBaseHeaders(),
                ...httpUtils.getMsBaseHeaders(window.userIdentity, "MEP"),
            },
        });
    }

    @autoBind
    uploadDocument(
        requestId: number,
        data: FormData
    ): Observable<Record<string, unknown>> {
        const endpoint =
            MedicineDeliveryDocumentRepository.getUploadUrl(requestId);
        const msHeaders = {
            ...new HttpUtils().getBaseHeaders(),
            ...httpUtils.getMsBaseHeaders(window.userIdentity, "MEP"),
        };
        /* Es necesario para que el navegador agregue el boundary al multipart/form-data */
        delete msHeaders["Content-Type"];

        const options = {
            data,
            customHeader: msHeaders,
            isFormData: true,
        };
        return this.http
            .post<Record<string, unknown>[]>(endpoint, options)
            .pipe(map((documents) => documents[0]));
    }

    @autoBind
    removeDocument(requestId: number, fileId: number): Observable<void> {
        const endpoint = MedicineDeliveryDocumentRepository.getRemoveUrl(
            requestId,
            fileId
        );
        return this.http.delete<void>(endpoint, {
            isPublicRequest: false,
            customHeader: {
                ...httpUtils.getBaseHeaders(),
                ...httpUtils.getMsBaseHeaders(window.userIdentity, "MEP"),
            },
        });
    }

    static getUploadUrl(requestId: number): string {
        return `insureds/me/requests/medicine-delivery/${requestId}/files`;
    }

    static getRemoveUrl(requestId: number, fileId: number): string {
        return `insureds/me/requests/medicine-delivery/${requestId}/files/${fileId}`;
    }

    static getBaseUrl(requestId: number): string {
        return `insureds/me/requests/medicine-delivery/${requestId}/files`;
    }
}
